import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c0334b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-10 px-0 pb-0 sm:px-12" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "py-6 text-red-600 text-2xl p-5 underline underline-offset-8" }, " Location ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "You can find The Motorbike Doctor at:", -1))
const _hoisted_4 = { class: "flex items-center justify-center py-10" }
const _hoisted_5 = { class: "location-map" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, null, -1))
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_l_tooltip = _resolveComponent("l-tooltip")!
  const _component_l_marker = _resolveComponent("l-marker")!
  const _component_l_map = _resolveComponent("l-map")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _hoisted_3,
      _createElementVNode("p", null, [
        _createElementVNode("b", null, [
          _createElementVNode("i", null, _toDisplayString(_ctx.address), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_l_map, {
          ref: "map",
          zoom: _ctx.zoom,
          center: [_ctx.latitude, _ctx.longitude]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_l_tile_layer, {
              url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
              "layer-type": "base",
              name: "OpenStreetMap"
            }),
            _createVNode(_component_l_marker, {
              "lat-lng": [_ctx.latitude, _ctx.longitude]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_l_tooltip, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.name), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["lat-lng"])
          ]),
          _: 1
        }, 8, ["zoom", "center"])
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_6,
      _createElementVNode("p", _hoisted_7, [
        _createTextVNode(" Click "),
        _createElementVNode("a", {
          class: "text-red-600 font-bold hover:text-lg hover:border-b hover:border-red-600",
          href: `https://goo.gl/maps/MjxW5aqMUJrfokYCA`,
          target: "_blank"
        }, "here", 8, _hoisted_8),
        _createTextVNode(" to get directions on Google Maps! ")
      ])
    ])
  ]))
}